import { createI18n } from 'vue-i18n'

let i18nInstance = null

const loadLocaleMessages = async () => {
  try {
    const messages = {}
    const supportedLocales = getSupportedLocales()
    for (const locale of supportedLocales) {
      messages[locale.value] = {}

      const modules = import.meta.glob('./languages/*/*.json', { eager: true })

      for (const path in modules) {
        if (path.includes(`/${locale.value}/`)) {
          const moduleName = path.match(/\/([^/]+)\.json$/)?.[1]
          if (moduleName) {
            messages[locale.value][moduleName] = modules[path].default
          }
        }
      }
    }
    return messages
  } catch (e) {
    console.error('加载语言包失败:', e)
    return {
      'zh-CN': {},
      'en-US': {}
    }
  }
}

export const getSupportedLocales = () => [
  { value: 'zh-CN', name: '简体中文' },
  { value: 'en-US', name: 'English' }
]

export const setupI18n = async () => {
  const messages = await loadLocaleMessages()

  i18nInstance = createI18n({
    legacy: false,
    locale: 'zh-CN',
    fallbackLocale: 'zh-CN',
    globalInjection: true,
    messages,
    missing: (locale, key) => {
      console.error(`[i18n] 缺少翻译: ${locale} - ${key}`)
      return key
    },
    warnHtmlMessage: false
  })

  return i18nInstance
}

export const getI18n = () => {
  if (!i18nInstance) throw new Error('i18n 未初始化')
  return i18nInstance
}
